
import { defineComponent, ref, onMounted, computed } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { HojokinType } from '@/repositories/fuzoku-meisai/junsoku/data'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { HojokinUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import HojokinSettingItem from '@/views/fuzoku-meisai/junsoku/HojokinSettingItem.vue'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.hojokin

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    HojokinSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    let kamokuSource: Kamoku[] = []
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const shisetsuItems = ref<HojokinUiItem[]>([])
    const uneiItems = ref<HojokinUiItem[]>([])
    const isAllValid = computed(() => {
      const allCount = shisetsuItems.value.length + uneiItems.value.length
      if (allCount === 0) {
        return true
      }
      const allValidCount = shisetsuItems.value.filter(i => i.isValid).length + uneiItems.value.filter(i => i.isValid).length
      return allCount === allValidCount
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        await refreshUiData()
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        let params = shisetsuItems.value.map(v => v.item)
        params = params.concat(uneiItems.value.map(v => v.item))
        await repository.save(params)
        await refreshUiData()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const addItem = (type: HojokinType) => {
      const targets = getUiItems(type)
      const newId = UiItemsLogic.makeId(targets)
      targets.push({
        isValid: false,
        item: {
          id: newId,
          itemName: '',
          type: type,
          issuer: '',
          overview: '',
          incomeSetting: {
            sources: [...kamokuSource],
            targets: []
          },
          debtSetting: {
            sources: [...kamokuSource],
            targets: []
          }
        }
      })
    }

    const upItem = (type: HojokinType, item: HojokinUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.upUiItem(items, item)
    }

    const downItem = (type: HojokinType, item: HojokinUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.downUiItem(items, item)
    }

    const trashItem = (type: HojokinType, item: HojokinUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.removeUiItem(items, item)
    }

    const onChangeInput = (type: HojokinType, item: HojokinUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.updateUiItem(items, item)
    }

    const getUiItems = (type: HojokinType) => {
      switch (type) {
        case 'ShisetsuSeibi':
          return shisetsuItems.value
        case 'Uneihi':
          return uneiItems.value
        default:
          throw Error('unknown type')
      }
    }

    const refreshUiData = async () => {
      const data = await repository.list()
      kamokuSource = data.kamokuSources
      shisetsuItems.value = data.items.filter(v => v.type === 'ShisetsuSeibi').map(value => ({ item: value, isValid: true }))
      uneiItems.value = data.items.filter(v => v.type === 'Uneihi').map(value => ({ item: value, isValid: true }))
    }

    return {
      loading,
      isAllValid,
      isSucceedRequest,
      requestError,
      shisetsuItems,
      uneiItems,
      onClickRegister,
      onDismissAlert,
      addItem,
      upItem,
      downItem,
      trashItem,
      onChangeInput
    }
  }
})
